import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { user, login, changePassword, logout } = useAuth();
    const navigate = useNavigate();
    const [forceChange, setForceChange] = useState(false);
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newPassword2, setNewPassword2] = useState('');
    const mustChange = forceChange || !!user?.mustChangePassword;

    const handleChange = async (e) => {
        e.preventDefault();
        setError('');
        if (newPassword.length < 10) return setError('Yeni şifre en az 10 karakter olmalı');
        if (newPassword !== newPassword2) return setError('Yeni şifreler eşleşmiyor');
        if (newPassword === currentPassword) return setError('Yeni şifre eskisiyle aynı olamaz');
        setLoading(true);
        try {
            await changePassword(currentPassword, newPassword);
            setForceChange(false);
            navigate('/admin');
        } catch (err) {
            setError(err.response?.data?.error || 'Şifre değiştirilemedi');
        }
        setLoading(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const data = await login(username, password);
            if (data?.mustChangePassword) {
                setCurrentPassword(password);
                setForceChange(true);
            } else {
                navigate('/admin');
            }
        } catch (err) {
            setError(err.response?.data?.error || 'Giriş başarısız');
        }
        setLoading(false);
    };

    if (mustChange) {
        return (
            <div className="login-page">
                <div className="login-card">
                    <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
                        <img src="/logo_noora.png" alt="Noora Privé" style={{ width: 80, height: 'auto', marginBottom: '0.5rem' }} />
                    </div>
                    <h1>Şifrenizi değiştirin</h1>
                    <p>Güvenliğiniz için ilk girişte yeni bir şifre belirlemeniz gerekiyor</p>

                    {error && <div className="login-error">{error}</div>}

                    <form onSubmit={handleChange}>
                        <div className="form-group">
                            <label>Mevcut Şifre</label>
                            <input type="password" className="form-control" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} autoComplete="current-password" required />
                        </div>
                        <div className="form-group">
                            <label>Yeni Şifre (en az 10 karakter)</label>
                            <input type="password" className="form-control" value={newPassword} onChange={e => setNewPassword(e.target.value)} autoComplete="new-password" minLength={10} required />
                        </div>
                        <div className="form-group">
                            <label>Yeni Şifre (Tekrar)</label>
                            <input type="password" className="form-control" value={newPassword2} onChange={e => setNewPassword2(e.target.value)} autoComplete="new-password" minLength={10} required />
                        </div>
                        <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: '0.5rem' }} disabled={loading}>
                            {loading ? 'Kaydediliyor...' : 'Şifreyi Değiştir'}
                        </button>
                        <button type="button" className="btn" style={{ width: '100%', justifyContent: 'center', marginTop: '0.5rem' }} onClick={() => { logout(); setForceChange(false); setCurrentPassword(''); }}>
                            Vazgeç
                        </button>
                    </form>
                </div>
            </div>
        );
    }

    return (
        <div className="login-page">
            <div className="login-card">
                <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
                    <img src="/logo_noora.png" alt="Noora Privé" style={{ width: 80, height: 'auto', marginBottom: '0.5rem' }} />
                </div>
                <h1>Admin Giriş</h1>
                <p>Noora Privé yönetim paneline hoş geldiniz</p>

                {error && <div className="login-error">{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Kullanıcı Adı</label>
                        <input type="text" className="form-control" value={username} onChange={e => setUsername(e.target.value)} placeholder="Kullanıcı adınız" required />
                    </div>
                    <div className="form-group">
                        <label>Şifre</label>
                        <input type="password" className="form-control" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required />
                    </div>
                    <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: '0.5rem' }} disabled={loading}>
                        {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
                    </button>
                </form>
            </div>
        </div>
    );
}
